module.exports = __webpack_public_path__ + "1da75d991516ee0e89cf5cb53ec59481.png";